// AUTO-GENERATED - DO NOT EDIT!
import gql from "graphql-tag";
import { useMutation, MutationHookOptions } from "@apollo/client";
import { nhsLoginSetup, nhsLoginSetupVariables } from "../types/nhsLoginSetup";

export const useNhsLoginSetupMutation = (
  opts: MutationHookOptions<nhsLoginSetup, nhsLoginSetupVariables>
) => {
  return useMutation<nhsLoginSetup, nhsLoginSetupVariables>(
    nhsLoginSetupMutation,
    opts
  );
};

export const nhsLoginSetupMutation = gql`
  mutation nhsLoginSetup(
    $setupToken: String!
    $consentMarketingPost: Boolean
    $consentMarketingEmail: Boolean
    $referralCodeId: ID
  ) {
    nhsLoginSetup(
      setupToken: $setupToken
      consentMarketingPost: $consentMarketingPost
      consentMarketingEmail: $consentMarketingEmail
      referralCodeId: $referralCodeId
    ) {
      tokens {
        accessToken
        refreshToken
      }
      account {
        id
        intercomId
        email
        firstName
        lastName
        hasIM1Enabled
        emailMarketingConsent {
          given
        }
        intercomUserHash
        patients {
          totalCount
          edges {
            node {
              id
              isAccountHolder
            }
          }
        }
      }
      error
      validationErrors {
        field
        message
      }
    }
  }
`;
